module.exports = __webpack_public_path__ + "media/images/icon__facebook@3x-a00a65b2a7fc7ac81a0314f7c4e17d24.png";